<div class="container grid-lg">
  <div class="columns label-columns">

    <div class="column col-auto col-md-12">
      <div class="footer-label text-light">
        {{ 'corporate_copyright_notice' | translate }}
      </div>
    </div>

    <div class="column col-md-12">
      <div class="footer-label">
        <a *ngIf="!termsLink" routerLink="/contact/terms" class="text-light"><u>{{ 'label_document_terms' | translate }}</u></a>
        <a *ngIf="termsLink" [href]="termsLink | safeUrl" target="_blank" class="text-light"><u>{{ 'label_document_terms' | translate }}</u></a>
      </div>
      <div class="footer-label">
        <a *ngIf="!privacyLink" routerLink="/contact/privacy" class="text-light"><u>{{ 'label_privacy_security' | translate }}</u></a>
        <a *ngIf="privacyLink" [href]="privacyLink | safeUrl" target="_blank" class="text-light"><u>{{ 'label_privacy_security' | translate }}</u></a>
      </div>
      <div class="footer-label" *ngIf="showServicesAgreementInFooter">
        <a class="text-light" href="http://www.billetexpressen.net/" target="_blank"><u>{{ 'label_ticket_services_agreement' | translate }}</u></a>
      </div>
    </div>

  </div>
</div>
